import { motion, type Transition } from 'motion/react';
import { memo } from 'react';

const animationSettings: Transition = {
  type: 'ease-in-out',
  repeat: Infinity,
  repeatType: 'reverse',
  duration: 2,
};

const MOTION_Y_TOP = -9;
const MOTION_Y_BASE = 0;
const MOTION_Y_MID = -8;
const MOTION_Y_DEEP = -18;

export const Animated404 = memo(() => {
  return (
    <div className="flex gap-2 font-control font-normal ads:text-ads-sky-12 text-[72px] text-blue-12">
      <motion.p animate={{ y: [MOTION_Y_TOP, MOTION_Y_BASE] }} transition={animationSettings}>
        4
      </motion.p>
      <motion.p animate={{ y: [MOTION_Y_BASE, MOTION_Y_MID] }} transition={animationSettings}>
        0
      </motion.p>
      <motion.p animate={{ y: [MOTION_Y_DEEP, MOTION_Y_TOP] }} transition={animationSettings}>
        4
      </motion.p>
    </div>
  );
});

Animated404.displayName = 'Animated404';
